module.exports = __webpack_public_path__ + "static/media/klima-02.90a7a677.jpg";